import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://instagram.com/nxndi_rfld" className="home__social-icon" data-aos="fade-right" target="_blank" rel="noopener noreferrer">
            <i className="uil uil-instagram-alt"></i>
        </a>

        <a href="https://github.com/nxndi" className="home__social-icon" data-aos="fade-right" data-aos-delay="200" target="_blank" rel="noopener noreferrer">
            <i className="uil uil-github-alt"></i>
        </a>
        
        <a href="https://www.linkedin.com/in/nandi-rifaldi-529b542b3?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" className="home__social-icon" data-aos="fade-right" data-aos-delay="300" target="_blank" rel="noopener noreferrer">
            <i className="uil uil-linkedin-alt"></i>
        </a>
    </div>
  )
}

export default Social